// autoimport_controller.js
import { Controller } from "stimulus"
// 
export default class extends Controller {
   connect() {
     this.element.replaceWith(this.element.content)
   }
 }
